/** @jsxImportSource @emotion/react */
import { memo, useCallback } from "react";
import { css } from "@emotion/react";

/**
 * 進捗度表示
 * @prop {Number} step どの画面まで進んでいるか
 */
const Progress = memo(({ step }) => {

  /**
   * 未入力、入力済み、現在地のいずれか判断し、適応するcssを返却するメソッド
   * @param {Number} circleNum 何番目の円か
   */
  const switchCircleCss = useCallback(
    (circleNum) => {
      return step === circleNum
        ? circle_current
        : step >= circleNum
          ? circle_completed
          : circle;
    },
    [step]
  );

  // 線の色が変わる位置
  const boundary = (100 / 4) * (step - 1) + "%";
  // 横線のどこで色を分けるか計算するためcssをこちらに定義
  const line = css`
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: calc(100% - 23px * 2);
    height: 2px;
    background: linear-gradient(
      90deg,
      var(--mtg-urbanblue) ${boundary},
      var(--mtg-urbanblue) ${boundary},
      var(--mtg-blue-4) ${boundary},
      var(--mtg-blue-4) 100%
    );
  `;

  return (
    <div css={wrap}>

      {/* パンくずリスト */}
      <div css={trailWrap}>
        <p css={trailText_sub}>出張お見積もり</p>
      </div>

      {/* 進捗バー */}
      <div css={progressWrap}>
        <span css={line}></span>
        <div css={step === 1 ? circleWrap_current : circleWrap}>
          <div css={switchCircleCss(1)}></div>
          <div css={progressTextWrap}>
            <p css={step === 1 ? progressText_completed : progressText}>
              希望日時
            </p>
          </div>
        </div>
        <div css={step === 2 ? circleWrap_current : circleWrap}>
          <div css={switchCircleCss(2)}></div>
          <div css={progressTextWrap}>
            <p css={step === 2 ? progressText_completed : progressText}>
              機器選択
            </p>
          </div>
        </div>
        <div css={step === 3 ? circleWrap_current : circleWrap}>
          <div css={switchCircleCss(3)}></div>
          <div css={progressTextWrap}>
            <p css={step === 3 ? progressText_completed : progressText}>
              お客さま情報
            </p>
          </div>
        </div>
        <div css={step === 4 ? circleWrap_current : circleWrap}>
          <div css={switchCircleCss(4)}></div>
          <div css={progressTextWrap}>
            {/* <p css={step === 4 ? progressText_completed : progressText}></p> */}
            <p css={step === 4 ? progressText_completed : progressText}>
              確認
            </p>
          </div>
        </div>
        <div css={step === 5 ? circleWrap_current : circleWrap}>
          <div css={switchCircleCss(5)}></div>
          <div css={progressTextWrap}>
            <p css={step === 5 ? progressText_completed : progressText}>
              完了
            </p>
          </div>
        </div>
      </div>
    </div>
  );
});

const wrap = css`
  margin-bottom: 16px;
  padding-bottom: 20px;

  @media screen and (max-width: 360px) {
    padding-bottom: 36px;
  }
`;

const trailWrap = css`
  display: flex;
  align-items: center;
  height: 18px;
  margin: 24px auto 16px;
  max-width: 338px;
`;

const trailText = css`
  font-size: var(--mtg-caption-strong-s);
  font-weight: var(--mtg-caption-strong-w);
`;
const trailText_sub = css`
  ${trailText}
  color: var(--mtg-midnight);
`;

const progressWrap = css`
  position: relative;
  display: flex;
  justify-content: space-between;
  max-width: 338px;
  margin: 0 auto;
  padding: 0 8px;
`;

const circleWrap = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  min-width: 30px;
  height: 30px;
  border-radius: 50%;
`;

const circleWrap_current = css`
  ${circleWrap}
  background-color: white;
`;

const circle = css`
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background-color: var(--mtg-blue-4);
`;

const circle_completed = css`
  ${circle}
  width: 16px;
  height: 16px;
  background-color: var(--mtg-urbanblue);
`;

const circle_current = css`
  ${circle}
  background-color: var(--mtg-urbanblue);
`;

const progressTextWrap = css`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;

  position: absolute;
  top: 34px;
  left: 50%;
  transform: translateX(-50%);

  width: 66px;

  @media screen and (max-width: 360px) {
    width: 55px;
  }
`;

const progressText = css`
  font-size: 11px;
  font-weight: 500;
  color: var(--mtg-grey-2);
`;

const progressText_completed = css`
  ${progressText}
  color: var(--mtg-blue-1);
`;

export default Progress;